// extracted by mini-css-extract-plugin
export default {"container":"ImagesDark_container__vcl4D","image":"ImagesDark_image__w-Ysz","slick-prev":"ImagesDark_slick-prev__IsBNb"};